import React from "react";
import { Link } from "react-router-dom";
import "./LumenButton.css";

type ButtonVariant =
  | "primary"
  | "light"
  | "outline"
  | "dark"
  | "outline-white"
  | "ghost-red";
type ButtonSize = "sm" | "md" | "lg";

interface LumenButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  to?: string; // if provided, renders as Link
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
}

const LumenButton: React.FC<LumenButtonProps> = ({
  children,
  to,
  className = "",
  variant = "primary",
  size = "md",
  block = false,
  ...rest
}) => {
  const classes = [
    "lumen-btn",
    `lumen-btn-${variant}`,
    `lumen-btn-${size}`,
    block ? "lumen-btn-block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link className={classes} to={to} role="button">
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
};

export default LumenButton;
